
































































































import AdUnit from "@/models/adUnit";
import Campaign, { LineItem } from "@/models/campaign";
import { DefinitionList } from "@/models/definition";
import DefinitionValue from "@/models/definitionValue";
import Setting from "@/models/setting";
import Site from "@/models/site";
import { get } from "lodash";
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class ChangeLogEntry extends Vue {
  @Prop({ default: "update" }) operation!: string;
  @Prop({ default: "" }) index!: string;
  @Prop({ default: () => [] }) changeLog!: any;
  @Prop({ default: () => [] }) modification!: any;
  @Prop({ default: null }) campaign!: Campaign;
  @Prop({ default: () => [] }) sites!: Site[];
  @Prop({ default: () => [] }) definitions!: DefinitionList[];
  @Prop({ default: () => [] }) adUnits!: AdUnit[];
  @Prop({ default: null }) settings!: Setting | null;

  invalidKeys = [
    "updatedAt",
    "Id",
    "targetUrlHistory",
    "bitlyHistory",
    "bitly",
    "contentType",
    "createdAt",
    "userId",
    "discount",
  ];

  getLineItem(id: string): LineItem | undefined {
    let lineItem = this.campaign.lineItems.find((i) => i.id === id);
    if (lineItem === undefined) {
      if (this.changeLog.entityInstance != null) {
        try {
          lineItem = new LineItem(this.changeLog.entityInstance);
        } catch (e) {
          lineItem = undefined;
        }
      }
    }

    return lineItem;
  }

  getSite(changeLog: any): string {
    const lineItem = this.getLineItem(changeLog.lineItemId);

    const site = lineItem
      ? this.sites.find((s) => lineItem.siteId === s.id)
      : null;

    return site ? site.name : "";
  }

  getAdUnit(changeLog: any): string {
    const lineItem = this.getLineItem(changeLog.lineItemId);
    const adUnit = lineItem
      ? this.adUnits.find((a) => lineItem.adUnitId === a.id)
      : null;
    return adUnit ? adUnit.name : "";
  }

  getDefinition(changeLog: any, type: string): string {
    const lineItem = this.getLineItem(changeLog.lineItemId);
    const environments = this.definitions.find((d) => d.value == type);
    let value: DefinitionValue | undefined;
    if (environments && lineItem) {
      lineItem?.definitionValueIds.forEach((l) => {
        const v = environments.values.find((e) => e.id === l);
        if (v) {
          value = v;
        }
      });
    }
    return value ? value.name : "";
  }

  composeChange(value: any, key: string, changeLog: any): string {
    let v: any = "";

    if (value === null) {
      return "";
    }

    if (key === "adUnitId") {
      v = this.adUnits.find((i) => i.id === value.$oid);
      v = v ? v.name : "";
    } else {
      v = value;
    }
    // if (changeLog.lineItemId) {

    // }

    return v;
  }

  composeBannerUrl(value: string, changeLog: any): string {
    let url = "";

    const lineItem = this.getLineItem(changeLog.lineItemId);

    if (lineItem?.banner && this.settings) {
      url = `${this.settings.assetsCdn}/uploads/banner/source/${lineItem.banner.id}/${value}`;
    }

    return url;
  }

  validKey(key: string): boolean {
    return !this.invalidKeys.includes(key);
  }
}
